import { apiClient } from './client';

/** Admin-triggered sync routes (POST). Each returns a 202 summary. */
export function syncIntune(): Promise<unknown> {
  return apiClient.post('/api/sync/intune');
}
/** Azure Arc servers -> Server assets (admin). Reads Arc, creates or links assets, resolves the matching Intune orphans. */
export function syncArc(): Promise<unknown> {
  return apiClient.post('/api/sync/arc');
}
/** Defender health for Intune-enrolled Windows devices (admin). Reads Intune's Defender state per device. */
export function syncDefender(): Promise<unknown> {
  return apiClient.post('/api/sync/defender');
}
/** Who still has CrowdStrike, from Intune's discovered apps (admin). Reads Intune; writes only oscar.AssetCrowdStrike. */
export function syncCrowdStrike(): Promise<unknown> {
  return apiClient.post('/api/sync/crowdstrike');
}
export function syncSystemAccounts(): Promise<unknown> {
  return apiClient.post('/api/sync/system-accounts');
}
/** Entra account sync: refresh linked People/Azure-app records + stage new accounts (account-model rework). */
export function syncAccounts(): Promise<unknown> {
  return apiClient.post('/api/sync/accounts');
}
export function syncDellWarranty(): Promise<unknown> {
  return apiClient.post('/api/sync/dell-warranty');
}

/**
 * Force the software provisioning sweep: reconcile mandatory role software for
 * everyone from their current department (the hourly job, on demand). Admin only.
 * Auto-reclaim is included when SOFTWARE_AUTO_REVOKE_ENABLED is on; otherwise
 * ReclaimPreview reports what it WOULD revoke.
 */
export interface SoftwareProvisionResult {
  PeopleAffected: number;
  Created: number;
  OverAllocatedPools: number;
  ReclaimEnabled: boolean;
  Reclaimed: number;
  ReclaimPreview: number;
}
export function runSoftwareProvisionSweep(): Promise<SoftwareProvisionResult> {
  return apiClient.post<SoftwareProvisionResult>('/api/onboarding/provision-software/run');
}
